import { AllowedFunction } from '@/services/auth/permissionsApi.types';

export function buildAllowedPermissionSet(allowed: AllowedFunction[]) {
  return new Set(allowed.map((a) => a.permissionKey));
}
